module.exports = __webpack_public_path__ + "img/mit-logo.272750ff.svg";